import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=6ce60a83&scoped=true"
import script from "./strategy.vue?vue&type=script&lang=js"
export * from "./strategy.vue?vue&type=script&lang=js"
import style0 from "./strategy.vue?vue&type=style&index=0&id=6ce60a83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce60a83",
  null
  
)

export default component.exports